<div class="loader" [class.no_expanded]="expanded" [class.no_menu]="noMenu" [class.gone]="!display" *ngIf="exists">
    <div>
        <span *ngFor="let l of n(9); let i = index" class="line line-{{i+1}}"></span>
    </div>
    <div>Loading</div>
</div>